import DisplayAdsBillboard from '@propertypal/shared/src/resources/images/display-ads/display-ads-billboard.png';
import DisplayAdsLargeMPU from '@propertypal/shared/src/resources/images/display-ads/display-ads-large-mpu.png';
import DisplayAdsSkyscraper from '@propertypal/shared/src/resources/images/display-ads/display-ads-skyscraper.png';
import DisplayAdsSmalMPU from '@propertypal/shared/src/resources/images/display-ads/display-ads-small-mpu.png';
import React from 'react';
import { SmallHeading, Text } from '../typography';
import {
  Container,
  Wrapper,
  DisplayType,
  DisplayTypes,
  DisplayTypeContent,
  Mockup,
  DisplayNumber,
  DisplayDetails,
  DisplayFeatures,
  DisplayFeature,
  MockupImg,
} from './DisplayAdverts.style';

interface DisplayAd {
  mockup: {
    maxW?: number;
    src: string;
  };
  title: string;
  dimensions: string;
  location: string;
  devices: string[];
}

const ads: DisplayAd[] = [
  {
    mockup: { src: DisplayAdsBillboard.src },
    title: 'Billboard',
    dimensions: '970x250',
    location: 'Top of search results page',
    devices: ['Desktop', 'Tablet Landscape'],
  },
  {
    mockup: { src: DisplayAdsSkyscraper.src },
    title: 'Skyscraper',
    dimensions: '160x600',
    location: 'Right hand side of search results',
    devices: ['Desktop', 'Tablet Landscape'],
  },
  {
    mockup: { src: DisplayAdsLargeMPU.src, maxW: 310 },
    title: 'Large MPU',
    dimensions: '300x600',
    location: 'Half way down search results',
    devices: ['Mobile only'],
  },
  {
    mockup: { src: DisplayAdsSmalMPU.src, maxW: 310 },
    title: 'Small MPU',
    dimensions: '300x350',
    location: 'Bottom of search results page',
    devices: ['Mobile only'],
  },
];

const DisplayAdverts: React.FC = () => {
  return (
    <Container>
      <Wrapper>
        <SmallHeading autoMargin align="center" fontSize={22} mb={70} fontWeight="normal">
          Four prominent advert placements on PropertyPal&apos;s website
        </SmallHeading>
        <DisplayTypes>
          {ads.map((ad, i) => (
            <DisplayType key={ad.title}>
              <Mockup>
                <MockupImg src={ad.mockup.src} alt={ad.title} maxW={ad.mockup.maxW} />
              </Mockup>
              <DisplayTypeContent>
                <DisplayNumber>{i + 1}</DisplayNumber>
                <DisplayDetails>
                  <Text display="flex" alignItems="center" gap={10}>
                    <DisplayNumber mob as="span">
                      {i + 1}
                    </DisplayNumber>
                    <span>{ad.title}</span>
                  </Text>
                  <DisplayFeatures>
                    <DisplayFeature>
                      <SmallHeading>Dimensions:</SmallHeading>
                      <Text>{ad.dimensions}</Text>
                    </DisplayFeature>
                    <DisplayFeature>
                      <SmallHeading>Location:</SmallHeading>
                      <Text>{ad.location}</Text>
                    </DisplayFeature>
                    <DisplayFeature>
                      <SmallHeading>Devices:</SmallHeading>
                      <ul>
                        {ad.devices.map((d) => (
                          <li key={d}>{d}</li>
                        ))}
                      </ul>
                    </DisplayFeature>
                  </DisplayFeatures>
                </DisplayDetails>
              </DisplayTypeContent>
            </DisplayType>
          ))}
        </DisplayTypes>
      </Wrapper>
    </Container>
  );
};

export default DisplayAdverts;
